import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sid = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        applySession(data.token, data.user);
        toast.success(`Benvenuto, ${data.user.name || data.user.email}`);
        navigate(data.user.role === "cliente" ? "/calendario" : "/dashboard", { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Accesso con Google non riuscito");
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-greige" data-testid="auth-callback">
      <span className="meta-label animate-pulse">ACCESSO CON GOOGLE IN CORSO…</span>
    </div>
  );
}
